import { AgropilotPermissionManagerService, SharedPermissionService } from '@agroone-front/shared'
import { UserPermissions } from '@agroone/entities'
import { Injectable, inject } from '@angular/core'
import { Router } from '@angular/router'
import { environment } from '@front-app-environments/environment'

@Injectable({
  providedIn: 'root',
})
export class SingleModuleAccessResolver {
  private permissionService = inject(SharedPermissionService)
  private agropilotPermissionManagerService = inject(AgropilotPermissionManagerService)
  private router = inject(Router)

  resolve(): boolean {
    const availablePermissions: UserPermissions[] = [
      UserPermissions.CROP_MODULE_ACCESS,
      UserPermissions.PLANTING_MODULE_ACCESS,
      UserPermissions.MASTERDATA_MODULE_ACCESS,
      UserPermissions.USER_MODULE_ACCESS,
    ]
    const permissions: UserPermissions[] = []
    for (const permission of availablePermissions) {
      if (this.permissionService.hasPermission(permission)) {
        permissions.push(permission)
      }
    }

    if (permissions.length === 1 && !this.agropilotPermissionManagerService.isGrantedAgropilotAccess()) {
      switch (permissions[0]) {
        case UserPermissions.PLANTING_MODULE_ACCESS:
          this.router.navigate(['/planting-management'])
          break
        case UserPermissions.CROP_MODULE_ACCESS:
          this.router.navigate(['/crop-management'])
          break
        case UserPermissions.MASTERDATA_MODULE_ACCESS:
          window.location.href = environment.masterdataUrl
          break
        case UserPermissions.USER_MODULE_ACCESS:
          this.router.navigate(['/user-management'])
          break
      }
      return false
    }

    if (permissions.length === 0 && this.agropilotPermissionManagerService.isGrantedAgropilotAccess()) {
      window.location.href = environment.agropilotUrl
    }

    return true
  }
}
